var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 3.375C7.93633 3.375 7.39583 3.59888 6.99732 3.9974C6.5988 4.39591 6.37492 4.93641 6.37492 5.5C6.37492 6.06358 6.5988 6.60409 6.99732 7.0026C7.39583 7.40112 7.93633 7.625 8.49992 7.625C9.0635 7.625 9.60401 7.40112 10.0025 7.0026C10.401 6.60409 10.6249 6.06358 10.6249 5.5C10.6249 4.93641 10.401 4.39591 10.0025 3.9974C9.60401 3.59888 9.0635 3.375 8.49992 3.375ZM8.49992 9.04167C7.56061 9.04167 6.65977 8.66853 5.99558 8.00434C5.33139 7.34015 4.95825 6.43931 4.95825 5.5C4.95825 4.56069 5.33139 3.65985 5.99558 2.99566C6.65977 2.33147 7.56061 1.95833 8.49992 1.95833C9.43923 1.95833 10.3401 2.33147 11.0043 2.99566C11.6684 3.65985 12.0416 4.56069 12.0416 5.5C12.0416 6.43931 11.6684 7.34015 11.0043 8.00434C10.3401 8.66853 9.43923 9.04167 8.49992 9.04167ZM8.49992 0.1875C4.95825 0.1875 1.93367 2.39042 0.708252 5.5C1.93367 8.60958 4.95825 10.8125 8.49992 10.8125C12.0416 10.8125 15.0662 8.60958 16.2916 5.5C15.0662 2.39042 12.0416 0.1875 8.49992 0.1875Z",
    fill: "#68717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconview);
export default __webpack_public_path__ + "static/media/iconview.b833b10c79cfe42e73fdba0102222fa1.svg";
export { ForwardRef as ReactComponent };